module.exports = __webpack_public_path__ + "img/Layer-7.67b9e600.webp";